var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.308,
    height: 26.705,
    viewBox: "0 0 27.308 26.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18370"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon open-data-transfer-download",
    d: "M13.2 0v10.24H6.377l10.24 10.24 10.24-10.24h-6.826V0z",
    transform: "translate(-2.964)",
    style: {
      fill: "#4b83b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon open-data-transfer-download",
    d: "M0 44.64v3.413h27.308V44.64z",
    transform: "translate(0 -21.349)",
    style: {
      fill: "#4b83b4"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtn);
export default __webpack_public_path__ + "static/media/download-btn.b0b1da7fd7965d2daca301e157bb9c44.svg";
export { ForwardRef as ReactComponent };